import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { FileUpload } from '@classes/file/file-upload';
import { UploadStatus } from '@enums/upload-status.enum';

@Component({
    selector: 'app-files-list',
    templateUrl: './files-list.component.html',
    styleUrls: ['./files-list.component.scss']
})
export class FilesListComponent implements OnInit {
    @Input() files: FileUpload[];
    @Output() removeFile = new EventEmitter<number>();

    uploadStatus = UploadStatus;

    constructor() { }

    ngOnInit() {
    }

    onRemoveFile(index: number): void {
        this.removeFile.emit(index);
    }
}
